export default {"src":"/_next/static/media/double-doc.4f43fa28.svg","height":29,"width":28,"blurWidth":0,"blurHeight":0};